module.exports = __webpack_public_path__ + "img/red-card-symbol.eb669cbc.svg";